// store/modules/permission.js
import { ANDROID_PERMISSION_LIST } from '@utils/constant';

const permission = {
  state: {
    permissionAuth: {
      cameraAuthorized: 'denied',
      microphoneAuthorized: 'denied',
      albumAuthorized: 'denied',
    }, // 初始化默认值
  },

  mutations: {
    SET_PERMISSION(state, settings) {
      state.permissionAuth = {
        ...state.permissionAuth, // 保留原有值
        ...settings, // 覆盖新值
      };
      console.log('权限更新成功:', state.permissionAuth);
    },
  },

  actions: {
    async updatePermissionAuth({ commit }) {
      try {
        const osName = uni.getSystemInfoSync().platform;
        const settings = uni.getAppAuthorizeSetting();
        console.log('settingssettings', settings);
        // 确保基础权限结构存在
        const basePermissions = {
          cameraAuthorized: settings.cameraAuthorized || 'denied',
          microphoneAuthorized: settings.microphoneAuthorized || 'denied',
          albumAuthorized: 'denied', // 默认值
        };

        if (osName === 'android') {
          // 安全执行Android权限检查
          const checkAndroidPermission = () =>
            new Promise((resolve) => {
              if (typeof plus.android.checkPermission !== 'function') {
                console.warn('plus.android API not available');
                return resolve('denied');
              }

              try {
                plus.android.checkPermission(ANDROID_PERMISSION_LIST.ALBUM, (granted) => {
                  resolve(granted.checkResult === 0 ? 'authorized' : 'denied');
                });
              } catch (e) {
                console.warn('Android permission check failed:', e);
                resolve('denied');
              }
            });

          basePermissions.albumAuthorized = await checkAndroidPermission();
        } else {
          // iOS直接使用系统返回的相册权限
          basePermissions.albumAuthorized = settings.albumAuthorized || 'denied';
        }

        console.log('最终权限对象:', basePermissions);
        commit('SET_PERMISSION', basePermissions);
      } catch (error) {
        console.error('更新权限失败:', error);
        // 提交默认权限状态
        commit('SET_PERMISSION', {
          cameraAuthorized: 'denied',
          microphoneAuthorized: 'denied',
          albumAuthorized: 'denied',
        });
      }
    },
  },
};

export default permission;
